module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-800-2f8f4d43aac53d1b881fcd50b08ac5e8.eot";